import React, { useContext, useMemo } from 'react';
import { HubIdContext } from 'app/App.jsx';
import RequirementMissing from 'app/views/dashboard/RequirementMissing';

const getHasHub = (hubIdContext) => {
  const hubId = (hubIdContext?.hubId || '').toString().trim();
  const hubList = hubIdContext?.hubList || {};
  const hubListCount = typeof hubList === 'object' && hubList ? Object.keys(hubList).length : 0;
  return hubId.length > 0 || hubListCount > 0;
};

const getHasPatient = (hubIdContext) => {
  const patient = hubIdContext?.patient;
  const patientUid = (patient?.patient_uid || patient?.data_get?.metadata?.uid || '').toString().trim();
  return patientUid.length > 0;
};

/**
 * Wrap a route element with hub/patient requirement checks.
 * If requirement is missing, render a placeholder *without navigating away*.
 */
export const RequireHub = ({ children }) => {
  const hubIdContext = useContext(HubIdContext);
  const hasHub = useMemo(() => getHasHub(hubIdContext), [hubIdContext]);

  if (!hasHub) return <RequirementMissing requirement="hub" />;
  return children;
};

export const RequirePatient = ({ children }) => {
  const hubIdContext = useContext(HubIdContext);
  const hasPatient = useMemo(() => getHasPatient(hubIdContext), [hubIdContext]);

  if (!hasPatient) return <RequirementMissing requirement="patient" />;
  return children;
};
